export default __webpack_public_path__ + "static/EngageLogoUpdated-5aa399a026da06072d6ed6bb8e3edd67.png";